<template>
  <div id="smartTown">
    <div class="flex">
      <img
        src="@/assets/images/pic200-13.png"
        style="width: 100%;max-width:561px;"
        alt=""
      />
    </div>
    <div class="flex">
      <img
        src="@/assets/images/pic200-14.png"
        style="width: 100%;max-width:561px;margin-top: 30px;"
        alt=""
      />
    </div>
      <div class="text">
该产品主要针对传染病报告卡人工上报不及时、漏报的情况，建设嵌入到医院前端的传染病直报系统，通过分析病历数据，实现传染病数据自动上报，提升及时性，减少漏报率。 系统通过前置方式将传染病直报系统嵌入医院业务系统中，帮助医院及时自动上报传染病数据，再通过省疾控大数据平台将传染病数据分别同步给省平台和国家疾控平台，从而实现各级机构的传染病数据共享，提升业务协同效率以应对传染病突发事件。      </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text{
  line-height: 24px;
  font-weight: 500;
    color: #666;
    margin-top: 30px;
    margin-right: 20px;
    text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/software8.vue